

























































import Vue from "vue";
import { callApi } from "@/lib/api";
import { showOkCancelDialog } from "@/lib/dialog";
import ManuscriptDeleteConfirm, {
  ManuscriptDeleteConfirmProps,
} from "@/components/ui/novel/ManuscriptDeleteConfirm.vue";
import { Dialog } from "@/lib/utils";
import { Manuscript } from "@/lib/models";

export default Vue.extend<Data, Methods, Computed, Props>({
  props: {
    novelId: String,
    selected: Object,
    items: Array as object,
    folder: Object,
    allFolders: Array as object,
    wordLength: Number,
  },

  data() {
    return {
      manuscripts: this.items,
      isEditMode: false,
      calling: false,
    };
  },

  watch: {
    items() {
      this.manuscripts = this.items;
    },
  },

  methods: {
    async select(manuscriptKey) {
      const { novelId } = this;

      if (this.isModified()) {
        const yes = await showOkCancelDialog({
          title: "確認",
          content: "保存されていない変更があります。<br />変更を破棄して戻りますか？",
          okButton: "破棄する",
          cancelButton: "キャンセル",
        });
        if (!yes) {
          return;
        }
      }
      this.setModified(false);

      if (manuscriptKey) {
        this.$router.push({
          name: "editor",
          params: {
            novelId,
            manuscriptKey,
          },
        });
      } else {
        this.$router.push({
          name: "editor",
          params: {
            novelId,
          },
        });
      }

      this.$emit("select", manuscriptKey);
    },
    async createManuscript() {
      const { novelId, folder } = this;
      const manuscriptFolderId = folder ? folder.manuscriptFolderId : null;

      this.$store.dispatch("manuscriptModule/createManuscript", {
        novelId,
        title: "",
        manuscriptFolderId,
        callback: () => {
          /** TODO: フォルダをstoreで扱うようになったら不要 */
          this.emitCreated();

          if (!this.isModified()) {
            this.select(this.createdManuscriptKey);
            this.$store.dispatch("manuscriptModule/initializeCreatedManuscriptKey");
          }
        },
      });
    },
    async moveManuscript(key, direction) {
      if (this.calling) return;
      this.calling = true;
      const { novelId } = this;
      if (this.folder) {
        const index = this.folder.manuscriptKeys.indexOf(key);
        if (direction === "up") {
          this.folder.manuscriptKeys.splice(
            index - 1,
            2,
            this.folder.manuscriptKeys[index],
            this.folder.manuscriptKeys[index - 1]
          );
        } else {
          this.folder.manuscriptKeys.splice(
            index,
            2,
            this.folder.manuscriptKeys[index + 1],
            this.folder.manuscriptKeys[index]
          );
        }
        const folders = this.allFolders;
        folders.forEach((element) => {
          if (element.manuscriptFolderId === this.folder.manuscriptFolderId) {
            element.manuscriptKeys = this.folder.manuscriptKeys;
          }
        });
        const { novelId } = this;
        const query = `
            mutation UpdateManuscriptFolders ($input: UpdateManuscriptFolderInput!){
              updateManuscriptFolder (input: $input) {
                novelId
                items {
                 manuscriptFolderId
                 name
                 manuscriptKeys
               }
              }
            }
        `;
        await callApi(query, {
          input: {
            novelId,
            items: folders,
          },
        });
        try {
          this.manuscripts.sort(
            (x, y) => this.folder.manuscriptKeys.indexOf(x.key) - this.folder.manuscriptKeys.indexOf(y.key)
          );
        } catch (error) {
          console.log(error);
        }
      } else {
        this.$store.dispatch("manuscriptModule/moveManuscript", {
          novelId,
          key,
          direction,
        });
      }

      this.calling = false;
    },
    async deleteManuscript(key, title) {
      const { novelId, getEpisodeIdFromNolaNovel } = this;
      const episodeId = getEpisodeIdFromNolaNovel(key);
      const confirmDialog = new Dialog(ManuscriptDeleteConfirm);
      const data: ManuscriptDeleteConfirmProps = {
        title,
        novelId,
        manuscriptId: key,
        episodeId,
      };

      const result = await confirmDialog.show(data);

      if (result) {
        if (!this.isModified()) {
          this.select();
        }

        this.$notify({
          title: "削除しました",
          type: "error",
        });
      }
    },
    backToFolderList() {
      this.$emit("backToFolderList");
    },
    setFolder(item) {
      this.$emit("clickSetFolder", {
        manuscript: item,
        manuscriptFolder: this.folder,
      });
    },
    previewAll() {
      this.$router.push({ name: "preview" });
    },
    emitCreated() {
      this.$emit("created");
    },

    getManuscript(id) {
      const { getters } = this.$store;
      return getters["manuscriptModule/manuscript"](id);
    },
    getEpisodeIdFromNolaNovel(manuscriptId) {
      const { getManuscript } = this;
      const manuscript = getManuscript(manuscriptId);
      if (!manuscript) {
        return undefined;
      }

      const { associatedData } = manuscript as Manuscript;

      if (!associatedData) {
        return undefined;
      }

      const { nolaNovel } = associatedData;

      if (!nolaNovel) {
        return undefined;
      }

      const { id } = nolaNovel;

      if (!id) {
        return undefined;
      }

      return id;
    },
  },

  computed: {
    totalWordLength() {
      let total: number = 0;
      if (this.items) {
        this.items.forEach((x) => {
          total += this.contentLength(x.content);
        });
      }
      return total;
    },
    remainingProgress() {
      const { wordLength, totalWordLength } = this;
      if (wordLength && totalWordLength) {
        return Math.floor((1 - totalWordLength / wordLength) * 100);
      }
      return "--";
    },
    unitProgress() {
      return (content) => {
        const { wordLength } = this;
        if (content && wordLength) {
          return Math.floor((this.contentLength(content) / wordLength) * 100);
        }
        return "--";
      };
    },
    contentLength() {
      return (content: string) => {
        let rubyLength = 0;

        const rubyRegExp = new RegExp("[|｜][^|｜\r\n]*?《.*?》", "gu");
        const textWithRuby = content.match(rubyRegExp);
        if (textWithRuby) {
          textWithRuby.forEach((text) => {
            const onlyRubyRegExp = new RegExp("《.*?》$");
            const textOnlyRuby = text.match(onlyRubyRegExp);
            rubyLength += textOnlyRuby![0].length + 1; // 親文字の縦棒をカウントから除くための+1;
          });
        }

        let contentLength = 0;
        switch (this.countType) {
          case "addBlank":
            contentLength = content.replace(/\n/g, "").length;
            break;
          case "addNewLine":
            contentLength = content.replace(/[^\S\n]/g, "").length;
            break;
          case "all":
            contentLength = content.length;
            break;
          case "onlyCharacter":
          default:
            contentLength = content.replace(/\s+|\n/g, "").length;
            break;
        }

        return contentLength - rubyLength;
      };
    },
    createdManuscriptKey() {
      return this.$store.getters["manuscriptModule/createdManuscriptKey"];
    },
    countType() {
      return this.$store.getters["manuscriptModule/countType"];
    },
  },
});

interface Props {
  novelId: string;
  selected: any;
  items: any[];
  folder: any;
  allFolders: any[];
  wordLength: number;
}

interface Data {
  manuscripts: any[];
  isEditMode: boolean;
  calling: boolean;
}

interface Methods {
  select: (manuscriptKey?: string) => Promise<void>;
  createManuscript: () => Promise<void>;
  moveManuscript: (key: string, direction: string) => Promise<void>;
  deleteManuscript: (key: string, title: string) => Promise<void>;
  backToFolderList: () => void;
  setFolder: (item: object) => void;
  previewAll: () => void;
  emitCreated(): void;

  getManuscript(manuscriptId: string): Manuscript | undefined;
  getEpisodeIdFromNolaNovel(manuscriptId: string): string | undefined;
}

interface Computed {
  totalWordLength: number;
  remainingProgress: number | string;
  unitProgress: (content: string) => number | string;
  contentLength: (content: string) => number;
  createdManuscriptKey: string;
  countType: string;
}
